import { render } from "./SaleSharedSummaryTab.vue?vue&type=template&id=ee3e5e2e"
import script from "./SaleSharedSummaryTab.vue?vue&type=script&lang=js"
export * from "./SaleSharedSummaryTab.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__